import './App.css';
import users from './components/users';
import auth from "./utils/authentication";
import {useAuthState} from 'react-firebase-hooks/auth';
import {FullWindowSpinner} from "./components/shared/";
import {Body} from "./components/app/";
import {BrowserRouter as Router} from 'react-router-dom';
import React, {useEffect, useState} from 'react';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {isMediumScreen, isMobileDevice, isSmallMediumScreen, isSmallScreen} from "./utils/utils";
import {useSelector} from "react-redux";
import {BackgroundProvider} from "./components/app/body/backgroundContext/backgroundContext";

function App() {
    const [user, loading, error] = useAuthState(auth);
    const [isMobile, setIsMobile] = useState(isMobileDevice());
    const [isSmall, setIsSmall] = useState(isSmallScreen());
    const [isMedium, setIsMedium] = useState(isMediumScreen());
    const [isMediumSmall, setIsMediumSmall] = useState(isSmallMediumScreen());
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);

    const darkMode = useSelector(users.selectors.isDarkMode);

    if (darkMode) {
        const htmlElement = document.getElementsByTagName('html')[0];
        htmlElement.setAttribute('data-bs-theme', 'dark');
    } else {
        const htmlElement = document.getElementsByTagName('html')[0];
        htmlElement.setAttribute('data-bs-theme', 'light');
    }

    useEffect(() => {
        let themeColorMeta = document.querySelector('meta[name="theme-color"]');
        if (!themeColorMeta) {
            themeColorMeta = document.createElement('meta');
            themeColorMeta.setAttribute('name', 'theme-color');
            document.head.appendChild(themeColorMeta);
        }
        const color = darkMode ? '#212529' : '#ffffff';
        themeColorMeta.setAttribute('content', color);
    }, [darkMode]);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(isMobileDevice());
            setIsSmall(isSmallScreen());
            setIsMedium(isMediumScreen());
            setIsMediumSmall(isSmallMediumScreen());
            setWindowHeight(window.innerHeight);
        };
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    if (loading) {
        return <FullWindowSpinner/>;
    }

    if (error) {
        return <div>Ocurrió un error: {error.message}</div>;
    }

    return (
        <div style={{overflow: 'hidden', height: windowHeight}}>
            <BackgroundProvider>
                <Router basename="/">
                    <Body/>
                </Router>
            </BackgroundProvider>
            <ToastContainer position="bottom-center"/>
        </div>
    );
}

export default App;
